// extracted by mini-css-extract-plugin
export default {"container":"dashboard_container__WBXJ-","main":"dashboard_main__At5cM"};